<ng-container *ngIf="loadingService.isLoading$ | async">
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>
